"use strict";

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* eslint-disable */


var SVG = function SVG(_a) {
  var _b = _a.style,
      style = _b === void 0 ? {} : _b,
      _c = _a.fill,
      fill = _c === void 0 ? '#fff' : _c,
      _d = _a.width,
      width = _d === void 0 ? '24px' : _d,
      _e = _a.height,
      height = _e === void 0 ? '24px' : _e,
      _f = _a.className,
      className = _f === void 0 ? '' : _f,
      _g = _a.rotation,
      rotation = _g === void 0 ? 0 : _g;
  return react_1["default"].createElement("svg", {
    className: className,
    width: width,
    style: style,
    height: height,
    transform: "rotate(" + rotation + ")",
    viewBox: '0 0 24 24'
  }, react_1["default"].createElement("path", {
    d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z',
    fill: fill
  }), react_1["default"].createElement("path", {
    d: 'M0 0h24v24H0z',
    fill: 'none'
  }));
};

exports["default"] = SVG;
/* eslint-enable */